import styled from 'styled-components';
import { zIndexNav } from '../../../../shared/styles/variables';

export const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: ${zIndexNav};
`;
